// import {IOption} from  './i-option';

// export class DropDownOption implements IOption {
//     value: any;
//     label: string;
//     disabled?: boolean;

//     constructor(_value?: any, _label?: string, _disabled?: boolean) {
//         this.value = _value;
//         this.label = _label;
//         this.disabled = _disabled;
//     }
// }

export class DropDownOption {
    value: any;
    label: string;
    disabled?: boolean;

    constructor(_value?: any, _label?: string, _disabled?: boolean) {
        this.value = _value;
        this.label = _label;
        this.disabled = _disabled;
    }
}


export class DropDownOptionWithGroup {
    groupName: string;
    optionList: Array<DropDownItemForGroup>;   
}

export class DropDownItemForGroup
{   
    value: any;
    label: string;
    disabled?: boolean;

    constructor(_value?: any, _label?: string, _disabled?: boolean) {
        this.value = _value;
        this.label = _label;
        this.disabled = _disabled;
    }

}

